//import Vue from "vue";
import { createStore } from "vuex";

import { CLIENT_ID, Tenant, Redirect_Uri } from "@/config/constants";

// Helpers
import { avActions } from "@/actions";
import AxiosFetchForMsal from "@/utils/axiosForMsal";
import { getMsalToken } from "@/utils/helpers";

//Vue.use(Vuex);

export const store = new createStore({
  state() {
    return {
      accessToken: sessionStorage.getItem("accessToken")
        ? sessionStorage.getItem("accessToken").replace(/['"]+/g, "")
        : "",
      avAccessToken: sessionStorage.getItem("avAccessToken")
        ? sessionStorage.getItem("avAccessToken").replace(/['"]+/g, "")
        : "",
      msalConfig: {
        auth: {
          clientId: CLIENT_ID,
          authority: `https://login.microsoftonline.com/${Tenant}/`,
          navigateToLoginRequestUrl: true,
          redirectUri: Redirect_Uri,
          postLogoutRedirectUri: Redirect_Uri
        },
        cache: {
          cacheLocation: "sessionStorage"
        }
      },
      tokenConfiguration: {},
      isAuth: false,
      username: {
        userEmail: ""
      },
      goBackToDashboardFromInsights: false,
      goBackToDashboardFromForecastDeepDive: false,
      productListVersion: 0,
      scenario: {
        name: '',
        type: ''
      },
      cloneScenario: {
        name: '',
        type: '',
        cloneName: '',
        cloneScenarioUid: '',
      }
    };
  },
  mutations: {
    setAccessType(state, accessType) {
      state.accessType = accessType;
    },
    getAccessToken(state, value) {
      state.accessToken = value;
    },
    setScenario(state, payload) {
      state.scenario.name = payload.name;
      state.scenario.type = payload.type;
      state.scenario.volumeForecastStatus = payload.volumeForecastStatus;
      state.scenario.stocksStatus = payload.stocksStatus;
      state.scenario.turnTimeAfterStocks = payload.turnTimeAfterStocks;
      state.scenario.outfleetSoldStatus = payload.outfleetSoldStatus;
      state.scenario.outfleetRedeliveryStatus = payload.outfleetRedeliveryStatus;
      state.scenario.outfleetLostStatus = payload.outfleetLostStatus;
      state.scenario.turnTimeAfterOutfleet = payload.turnTimeAfterOutfleet;
      state.scenario.infleetStatus = payload.infleetStatus;
      state.scenario.turnTimeAfterInfleet = payload.turnTimeAfterInfleet;
      state.scenario.purchaseLeaseStatus = payload.purchaseLeaseStatus;
    },
    setCloneScenario(state, payload) {
      state.cloneScenario.name = payload.name;
      state.cloneScenario.type = payload.type;
      state.cloneScenario.cloneName = payload.cloneName;
      state.cloneScenario.cloneScenarioUid = payload.cloneScenarioUid;
    },
    setAccessToken(state, token) {
      state.tokenConfiguration = token;
      state.accessToken = token.access_token;
    },
    setAVAccessToken(state, token) {
      state.avAccessToken = token.access_token;
    },
    setUserData(state, userData) {
      state.username = userData;
    },
    setActivityTasks(state, value) {
      state.activityTasks = value;
    },
    setUserEmail(state, payload) {
      this.state.username.userEmail = payload;
    },
    isUserAuthorized(state, payload) {
      state.isAuth = payload;
    },
    setInitialGoBackState(state, payload){
      state.goBackToDashboardFromInsights = payload;
      state.goBackToDashboardFromForecastDeepDive = payload;
    },
    setBackToDashboard(state, payload){
      state.goBackToDashboardFromInsights = payload;
    },
    setBackToDashboardFromForecastDeepDive(state, payload){
      state.goBackToDashboardFromForecastDeepDive = payload;
    },
    refreshProductList(state) {
      state.productListVersion += 1;
    }
  },

  actions: {
    updateScenario({ commit }, scenario) {
      commit('setScenario', scenario);
    },
    cloneScenario({ commit }, scenario) {
      commit('setCloneScenario', scenario);
    },
    reportScenario({ commit }, scenario) {
      commit('setScenario', scenario);
    },
    viewScenario({ commit }, scenario) {
      commit('setScenario', scenario);
    },
    summaryScenario({ commit }, scenario) {
      commit('setScenario', scenario);
    },
    async userActivity({ commit }) {
      const accessToken = localStorage.getItem("accessToken");
      if (accessToken) {
        const idToken = await getMsalToken(this, "av_msal_token");
        const payload = await avActions.getUserActivity(idToken);
        await AxiosFetchForMsal(payload)
          .then((response) => {
            commit("setActivityTasks", response);
          })
          .catch((error) => {
            console.error(error);
          });
      }
    },
    setUserDataAction({ commit }, token) {
      commit("setUserData", token);
    },
    setAccessTokenAction({ commit }, token) {
      commit("setAccessToken", token);
    },
    setAVAccessTokenAction({ commit }, token) {
      commit("setAVAccessToken", token);
    }
  },
  getters: {
    getTokenData(state) {
      return state.tokenConfiguration;
    },
    username(state) {
      return state.username;
    },
    accessToken(state) {
      return state.accessToken;
    },
    avAccessToken(state) {
      return state.avAccessToken;
    },
    getGoBackState(state){
      return state.goBackToDashboardFromInsights;
    },
    getGoBackStateFromForecastDeepDive(state){
      return state.goBackToDashboardFromForecastDeepDive;
    }
  }
});
